import { render, staticRenderFns } from "./LocationDataTable.vue?vue&type=template&id=dcbbf76a&scoped=true&"
import script from "./LocationDataTable.vue?vue&type=script&lang=js&"
export * from "./LocationDataTable.vue?vue&type=script&lang=js&"
import style0 from "./LocationDataTable.vue?vue&type=style&index=0&id=dcbbf76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbbf76a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTooltip})
